import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { InspectionServiceTypeEnum } from '~/shared/config/enums'
import { TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type ServiceProps = {
  loading: boolean
}

export function Service({ loading }: ServiceProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('form.service')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={6}>
          <TextInput
            label='form.oil top up'
            name={`services.${InspectionServiceTypeEnum.MOTOR_OIL}`}
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.antifreeze top up'
            name={`services.${InspectionServiceTypeEnum.ANTIFREEZE}`}
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.lamp replacement'
            name={`services.${InspectionServiceTypeEnum.LAMPS}`}
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.wiper replacement'
            name={`services.${InspectionServiceTypeEnum.WIPERS}`}
            readOnly
            skeletonShow={loading}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
